import { Spin } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { productSelectionStore } from "src/store/atoms";
import { getActiveLimiterRequest } from "src/store/fetchers";
import { getMeRequest } from "src/store/fetchers/getMeRequest";

export const ClientPage = () => {
  const getMe = useAction(getMeRequest);
  const getActiveLimiter = useAction(getActiveLimiterRequest);
  const [isReady, setIsReady] = useState(false);

  useAtom(productSelectionStore.selectedIdsAtom, []);

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval>;

    const loadInitialData = async () => {
      try {
        await Promise.all([getMe(), getActiveLimiter()]);
      } finally {
        setIsReady(true);

        intervalId = setInterval(() => {
          getMe();
          getActiveLimiter();
        }, 10000);
      }
    };

    // eslint-disable-next-line react-you-might-not-need-an-effect/no-external-store-subscription -- бутстрап данных + polling-интервал, а не подписка на внешний стор
    loadInitialData();

    return () => clearInterval(intervalId);
  }, [getMe, getActiveLimiter]);

  if (!isReady) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "50vh",
        }}
      >
        <Spin size="l" />
      </div>
    );
  }

  return <Outlet />;
};
